<template>
    <b-overlay :show="logging_out" rounded="lg">
        <div class="container-scroller">
            <dashboard-navbar
                @toggle-class="() => (toggleSidebar = !toggleSidebar)"
                @toggle-sidebar="() => (sidebar = !sidebar)"
            >
            </dashboard-navbar>
            <b-container fluid class="page-body-wrapper px-0">
                <div
                    class="sidebar sidebar-offcanvas"
                    :class="{ active: toggleSidebar }"
                >
                    <b-nav>
                        <nav
                            class="nav-item"
                            @load="handleImageLoad"
                            @mouseover="() => (mouseHover = 'dash')"
                            @mouseleave="() => (mouseHover = false)"
                            :class="{
                                'hover-open': mouseHover === 'dash',
                                active:
                                    paths[1] && paths[1].text == 'dashboard',
                            }"
                            @click="parentGroup = null"
                        >
                            <router-link class="nav-link" to="/ams/dashboard">
                                <span class="menu-title">{{
                                    $translate('dashboard')
                                }}</span>
                                <img
                                    src="@/assets/images/icon/11-active.svg"
                                    class="menu-icon-bar"
                                />
                            </router-link>
                        </nav>
                        <li
                            class="nav-item"
                            v-for="(x, idx) in linkGroups"
                            @mouseenter="() => (mouseHover = idx)"
                            @mouseleave="() => (mouseHover = false)"
                            :class="{
                                'hover-open': sidebar && mouseHover === idx,
                                active: x.group === activeParent,
                            }"
                            :key="x.group"
                        >
                            <b-link
                                v-b-toggle="`collapse${idx}`"
                                variant="light"
                                class="nav-link"
                                :aria-controls="`collapse${idx}`"
                            >
                                <span class="menu-title">{{
                                    getGroupName(x.group)
                                }}</span>
                                <i class="menu-arrow"></i>
                                <img :src="x.children[0].icon" />
                            </b-link>
                            <b-collapse
                                accordion="menu-accordion"
                                :id="`collapse${idx}`"
                                :visible="x.group === activeParent"
                                :style="{
                                    display:
                                        sidebar && mouseHover === idx
                                            ? 'block'
                                            : 'none',
                                }"
                            >
                                <b-list-group class="nav flex-column sub-menu">
                                    <b-list-group-item
                                        class="nav-item border-0"
                                        v-for="(item, index) in x.children"
                                        :key="index"
                                        :to="item && item.path"
                                    >
                                        <i :class="item.icon"></i>
                                        <span
                                            class="nav-link"
                                            :class="{
                                                active:
                                                    item.path ===
                                                        (paths &&
                                                            paths[1] &&
                                                            paths[1].path) ||
                                                    item.path ===
                                                        activeComponents ||
                                                    item.path ===
                                                        activeInnerComponents,
                                            }"
                                        >
                                            {{
                                                $translate(
                                                    item && item.displayName
                                                )
                                            }}
                                        </span>
                                    </b-list-group-item>
                                </b-list-group>
                            </b-collapse>
                        </li>
                        <li class="client-logo">
                            <img
                                src="@/assets/images/innovate10x.png"
                                class="menu-icon-bar"
                            />
                        </li>
                    </b-nav>
                </div>
                <div class="main-panel">
                    <div
                        class="content-wrapper"
                        :class="{ 'common-class': !isDashboard }"
                    >
                        <!--Header Content -->
                        <div class="page-header">
                            <h3 class="page-title">
                                <span
                                    class="page-title-icon d-inline-flex justify-content-center align-items-center bg-gradient-primary text-white me-2"
                                >
                                    <i class="mdi mdi-home"></i>
                                </span>
                                <span>
                                    <router-link
                                        to="dashboard"
                                        class="text-decoration-none text-black"
                                        >Ams</router-link
                                    >
                                    <span>/</span>
                                    <router-link
                                        :to="getPathLocation"
                                        class="text-decoration-none text-black"
                                        >{{
                                            $translate(
                                                paths[1] && paths[1].displayName
                                            )
                                        }}</router-link
                                    >
                                </span>
                            </h3>
                        </div>
                        <portal-target name="dashboardStatsCards">
                        </portal-target>

                        <fade-transition
                            :duration="200"
                            origin="center top"
                            mode="out-in"
                        >
                            <!-- your content here -->
                            <router-view></router-view>
                        </fade-transition>
                    </div>
                    <content-footer />
                </div>
            </b-container>
        </div>
    </b-overlay>
    <!-- </body> -->
</template>
<script>
//npm components
import { capitalCase, sentenceCase } from 'change-case'
import { FadeTransition } from 'vue2-transitions'
//local components
import DashboardNavbar from './DashboardNavbar.vue'
import ContentFooter from './ContentFooter.vue'
//mixins
import layoutMixins from '@/mixins/layoutMixins'
export default {
    components: {
        DashboardNavbar,
        ContentFooter,
        FadeTransition,
    },
    mixins: [layoutMixins],
    data() {
        return {
            activeChild: null,
            toggleSidebar: false,
            adminRouteItems: [],
            mouseHover: false,
            sidebar: false,
            parentGroup: null,
            paths: [],
        }
    },
    filters: {
        parseLinkName(x) {
            return capitalCase(
                sentenceCase(
                    x
                        .replace(/orders/g, 'activities')
                        .replace(/order/g, 'activity')
                )
            )
        },
    },
    computed: {
        getPathLocation() {
            const path = this.paths[1] && this.paths[1].path
            return typeof path == 'string' ? path : {}
        },
        isDashboard() {
            return this.$route.path.includes('dashboard')
        },
        activeParent() {
            const pathGroup =
                this.paths &&
                this.paths[1] &&
                (this.paths[1].group || this.paths[1].activeGroup)
            console.log(this.paths, 'pathGroup')
            return pathGroup
        },
        activeInnerComponents() {
            return this.$route.meta.subPath
        },
        activeComponents() {
            return this.$route.path
        },
        user() {
            return this.$store.state.user
        },
        logging_out() {
            return this.$store.state.logging_out
        },
    },
    watch: {
        $route() {
            this.calcPath()
            this.activeChild = this.paths[1].path
            console.log(this.toggleSidebar)
            document.title = `AMS - ${this.$translate(this.paths[1].displayName)}`
        },
        sidebar() {
            console.log(this.sidebar, 'this.sidebar')
        },
    },
    created() {
        const user_id = this.user.id
        this.$store.dispatch('notifications/checkNotificationToggle', {
            user_id,
        })
    },
    mounted() {
        console.log('inventory_usage', this.$translate('inventory_usage'))
        this.calcPath()
        console.log('PATHOFPAGE', this.paths)
        document.title = `AMS - ${this.$translate(this.paths[1].displayName)}`
    },
    methods: {
        getGroupName(name) {
            const groupName =
                name &&
                name
                    .replace(/orders/g, 'activities')
                    .replace(/order/g, 'activity')
            return this.$translate(groupName)
        },
        handleImageLoad() {
            console.log('Image loaded!')
        },
        calcPath() {
            let pathSplit = this.$route.path.split('/')
            let group = this.$route.meta.group
            let activeGroup = this.$route.meta.activeGroup
            let displayName = this.$route.meta.displayName
            console.log(this.$route.meta.displayName, 'groupPath')
            pathSplit.splice(0, 1)

            let paths = []
            let runningPath = ''
            for (let segment of pathSplit) {
                runningPath += '/' + segment
                paths.push({
                    displayName,
                    path: runningPath,
                    text: segment,
                    activeGroup,
                    group,
                })
            }
            this.paths = paths
        },
    },
}
</script>
